<template>
  <div class="view-workout-meet container text-light py-5">
    <router-link
      :to="{ name: 'workout' }"
      class="text-secondary small text-decoration-none"
    >
      <i class="fas fa-chevron-left" /> Seja forte
    </router-link>

    <h5 class="my-4">Academia on-line</h5>

    <action-dispatcher action="workout/getMeet" @success="successLoad">
    </action-dispatcher>
    <div id="meetingSDKElement" class="w-100 d-block"></div>
  </div>
</template>

<script>
import { mapState } from "vuex";
import ZoomMtgEmbedded from "@zoom/meetingsdk/embedded";

export default {
  computed: {
    ...mapState("workout", ["meet"])
  },
  methods: {
    successLoad() {
      let meetingSDKElement = document.getElementById("meetingSDKElement");
      const client = ZoomMtgEmbedded.createClient();
      client
        .init({
          zoomAppRoot: meetingSDKElement,
          language: "pt-BR",
          patchJsMedia: true,
          customize: {
            video: {
              isResizable: false,
              viewSizes: {
                default: {
                  width: 1110,
                  height: 500
                }
              }
            }
          }
        })
        .then(() => {
          client.join({
            signature: this.meet.token,
            meetingNumber: this.meet.meeting_id.replaceAll(" ", ""),
            userName: this.$user.user.name,
            sdkKey: "TvcLv1iGQ1nNPPP84mHvQ",
            userEmail: this.$user.user.email,
            password: this.meet.meeting_password
          });
        });
    }
  }
};
</script>

<style lang="scss">
.view-workout-meet {
  .zmwebsdk-makeStyles-videoCustomize-1,
  .zmwebsdk-makeStyles-wrap-44,
  .zmwebsdk-makeStyles-wrap-49 {
    max-width: 100%;
  }

  .zmwebsdk-MuiPaper-root,
  .zmwebsdk-MuiBox-root {
    width: 100%;
  }
}
</style>
